import { Injectable } from '@angular/core';
import { SelectionServiceBase } from './selection-base';
import { Route } from './routes';
import { StorageMap } from '@ngx-pwa/local-storage';

@Injectable({ providedIn: 'root' })
export class RouteSelectionService extends SelectionServiceBase<Route> {
  constructor(storage: StorageMap) {
    super(storage, 'selectedRoute'); // Key used in localStorage
  }
}
